module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1cKUvv0LA4gO6agkooeI6e-1fdcbee1c27aa6635c0b636b1a2a6156.jpg";